import Callinputs from './call_inputs'

const Form = ({ data }: any) =>
  data.map((item: any) => <Callinputs {...item} />)
export default Form
